import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'svg-inline',
  props: {
    name: {
      type: String,
      required: true,
    },
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: null,
      required: false,
    }
  },
  setup(__props) {

const props = __props;


  const path = props.src || 'img/svg/';

  const svg = computed( () => {
    return path + props.name + '.svg';
  });

  const svgClass = computed( () => {
    return `icon icon--${props.name}`;
  });

return (_ctx: any,_cache: any) => {
  const _directive_svg_inline = _resolveDirective("svg-inline")!

  return _withDirectives((_openBlock(), _createElementBlock("img", {
    class: _normalizeClass(_unref(svgClass)),
    src: _unref(svg),
    alt: props.alt || props.name
  }, null, 10, _hoisted_1)), [
    [_directive_svg_inline]
  ])
}
}

})